import React, {Component} from "react";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {
  ROOM_DETAIL_LINK,
  ROOM_FORM_LINK,
  FIND_PAGE_ARRANGEMENT_URL,
  GET_TOKEN_BYKEY_URL,
  CHECK_TOKEN_URL
} from "../actions/types";
import {checkAuth} from "../actions/index";
import Header from "./Header";
import Nav from "./Nav";
import IndexCalendar from "./IndexCalendar";
import IconFilter from "../images/icon_filter.png";
import ArrangementMore from "../images/arrangement_more.png";
import DownPng from "../images/icon_down.png";
import axios from "axios";
import {DatePicker, MuiPickersUtilsProvider} from "material-ui-pickers";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIos from "@material-ui/icons/ArrowForwardIos";
import CloseIcon from "@material-ui/icons/Close";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Button from "@material-ui/core/Button";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import Collapse from "@material-ui/core/Collapse";
import moment from "moment";
import "moment/locale/zh-cn";
import MomentUtils from "@date-io/moment";
import {indexColor} from "../constName.json";
import index_flex from '../images/index_flex.png'
import color from "@material-ui/core/colors/red";
import icon_count from '../images/icon_count.svg'
import IconVideo from "../images/icon_video_black.svg";
import IconLaptop from "../images/icon_laptop_black.svg";
import IconBlackboard from "../images/icon_blackboard_black.svg";
import Iconspeaker from "../images/icon_speaker_black.svg";
import IconIndexList from "../images/icon_index_list.png";
import IconIndexPic from "../images/icon_index_pic.png";
// import Tabs from "@material-ui/core/Tabs";
// import Tab from "@material-ui/core/Tab";
// axios.defaults.withCredentials = true;
class Index extends Component {
  state = {
    meetingRoom: [],
    detailRoom: {},
    date: moment(),
    filter: false,
    scroll: false,
    checked: false,
    value: 2,
    index: 0,
    drop: false,
    moveLet: true,
    showstyle: "barlist",
    daylimit: 14,
    userInfo: {flag: true}
  };

  getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    // console.log(this.props.history.location.search);return;
    var r = this.props.history.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  }

  componentDidMount() {
    window.addEventListener("scroll", this.orderScroll.bind(this));
    this.getReservations();
    let key = this.getQueryString("key");
    if (key) {
      axios.get(`${GET_TOKEN_BYKEY_URL}/${key}`).then(res => {
        localStorage.setItem("X-AUTH-TOKEN", res.data);
        this.props.checkAuth();
      });
    }
    let token = this.getQueryString("token");
    if (token) {
      localStorage.setItem("X-AUTH-TOKEN", token);
    }
    this.props.checkAuth();
    let _this = this;
    // axios.get(`/lab/rest/reservations/getLimit`).then(res => {
    //   console.log(res);
    // });
    axios({
      method: "get",
      url: `${CHECK_TOKEN_URL}`,
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("X-AUTH-TOKEN")
      }
    }).then(function (res) {
      console.log(res)
      _this.setState({userInfo: res.data.userInfo});
    }).catch(err => {
    })
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.orderScroll.bind(this));
    this.setState = (state, callback) => {
      return;
    };
  }

  orderScroll(eve) {
    if (window.scrollY <= 0) {
      if (this.state.scroll) {
        this.setState({scroll: false});
      }
    } else {
      if (!this.state.scroll) {
        this.setState({scroll: true});
      }
    }
  }

  getReservations() {
    const {date, detailRoom} = this.state;
    if (detailRoom.id) {
      axios({
        method: "get",
        url: `${FIND_PAGE_ARRANGEMENT_URL}?date=${date.format("YYYY-MM-DD")}&id=${detailRoom.id}`
      }).then(res => {
        if (Array.isArray(res.data)) {
          let meetingRoom = res.data.filter(room => {
            return room.type === "meeting";
          });
          this.setState({
            detailRoom: meetingRoom[0],
            value: meetingRoom[0].id
          });
        }
      });
    } else {
      axios({
        method: "get",
        url: `${FIND_PAGE_ARRANGEMENT_URL}?date=${date.format("YYYY-MM-DD")}`
      }).then(res => {
        if (Array.isArray(res.data)) {
          let meetingRoom = res.data.filter(room => {
            return room.type === "meeting";
          });
          this.setState({meetingRoom: meetingRoom, value: meetingRoom[0].id});
        }
      });
    }
  }

  minusDate() {
    this.setState({date: this.state.date.subtract(1, "days")}, () =>
      this.getReservations()
    );
  }

  plusDate() {
    this.setState({date: this.state.date.add(1, "days")}, () =>
      this.getReservations()
    );
  }

  handleDateChange(date) {
    let c_date = new Date();
    let s_date = date._d;
    let flag = c_date.getFullYear() < s_date.getFullYear() || c_date.getMonth() < s_date.getMonth() || c_date.getDate() <= s_date.getDate();
    let end = moment();
    end.add(this.state.daylimit, "days");
    if (end < date && this.state.userInfo.flag) {
      return alert(`请选择${this.state.daylimit}天以内的时间进行预约。`);
    }
    if (flag) {
      this.setState({index: 0});
      this.setState({date: date, checked: false}, () => this.getReservations());
    } else {
      alert('请选择今天及以后的日期!!!');
      this.setState({index: 0, checked: false});
    }
  }

  addBodyFixed() {
    // document.getElementsByClassName('index-date-bg')[0].style['transform'] = "translateY(0px)";
    // document.getElementsByClassName('index-calendar-collapse')[0].style['min-height'] = "500px";
    // document.getElementsByClassName('index-date-arrow')[0].style['transform'] = "rotate(180deg)";
    this.setState({drop: true})
    document.body.style.position = "fixed";
    this.refs.dp.open();
  }

  render() {
    const {scroll, detailRoom} = this.state;
    return (
      <React.Fragment>
        <Header scroll={scroll}/>
        {false && this.renderIndexFilterSection()}
        {this.renderIndexCalendar()}
        <div className="container"
             style={{
               paddingTop: 24,
               background: "#F8FAFB",
               borderRadius: 8,
               marginTop: "-8px",
               width: "100vw"
             }}>
          <div hidden={true} className="index_flex"><img src={index_flex}/></div>
          <div className="index-filter-room">
            <span className="index-filter-room-name">{detailRoom.name || ""}</span>
            <span className="index-filter-room-button">
                <div className="index_flex_r" onClick={() => {
                  if (this.state.showstyle == "barlist") {
                    this.setState({showstyle: "piclist"})
                    this.setState({detailRoom: {}})
                  } else {
                    this.setState({showstyle: "barlist"})
                  }
                }}>
                  {this.state.showstyle == "piclist" && <img src={IconIndexList}/>}
                  {this.state.showstyle == "barlist" && <img src={IconIndexPic}/>}
                </div>
                <span hidden={true} onClick={() => this.setState({filter: true})}>
                  <img src={IconFilter} alt="icon" height={12} style={{marginRight: 4}}/>
                  <span>筛选</span>
                </span>
              </span>
          </div>
          <section
            className={"barlist"}>{this.state.showstyle == "barlist" && this.renderMeetingRoom()}</section>
          <section
            className={"piclist"}>{this.state.showstyle == "piclist" && this.renderMeetingRoom_pic()}</section>
          {false && this.renderTabs()}
        </div>
        {this.renderFilterDiv()}
        <Nav/>
      </React.Fragment>
    );
  }

  renderIndexCalendar() {
    if (this.state.drop) {
      this.setState({drop: false});
      this.setState({index: 0});
      document.getElementsByClassName('index-date-bg')[0].style['transform'] = "translateY(180px)";
      document.getElementsByClassName('index-calendar-collapse')[0].style['min-height'] = "90px";
      document.getElementsByClassName('index-date-arrow')[0].style['transform'] = "rotate(0deg)";
    }
    const {date, checked, index} = this.state;
    let dateWidth = 0;
    let collapsedHeight = "";
    if (document.getElementsByClassName("index-detail-date").length !== 0) {
      dateWidth = document.getElementsByClassName("index-detail-date")[0].clientWidth;
      collapsedHeight = 40 + document.getElementsByClassName("index-detail-date")[0].clientHeight + "px";
    }
    let self = this;
    setTimeout(function () {
      return 0;
      let IndexCalendar = document.getElementsByClassName("index-calendar-view")[0];
      let startX;
      let startY;
      let touchstart = function (e) {
        e.preventDefault();
        let moveEndX = e.changedTouches[0];
        startX = moveEndX.clientX;
        startY = moveEndX.clientY;
        console.log("touchstart", startX, startY)
      };
      let touchend = async function (e) {
        e.preventDefault();
        let moveEndX = e.changedTouches[0];
        let endX = moveEndX.clientX;
        let endY = moveEndX.clientY;
        let moveX = endX - startX;
        let moveY = endY - startY;
        if (moveX === 0) {
          let div = e.explicitOriginalTarget.parentElement;
          if (div.classList.contains("index-detail-date")) {
            div.click()
          } else if (e.explicitOriginalTarget.classList.contains("index-detail-date")) {
            e.explicitOriginalTarget.click()
          }
          return
        }
        if (!self.state.moveLet) {
          return
        } else {
          self.setState({moveLet: false});
          setTimeout(function () {
            self.setState({moveLet: true});
          }, 300)
        }
        if (moveX > 0) {
          let sy = date._d.getFullYear() * 12 + date._d.getMonth();
          let cy = new Date().getFullYear() * 12 + new Date().getMonth();
          let disable = self.state.index + sy - cy <= 0;
          if (!disable) {
            self.setState({index: self.state.index - 1})
          }
        } else if (moveX < 0) {
          self.setState({index: self.state.index + 1})
        }
      };
      IndexCalendar.addEventListener("touchstart", touchstart, false);
      IndexCalendar.addEventListener("touchend", touchend, false);
    }, 100);
    return (<div>
      <div className="index-calendar">
        <div className="index-calendar-bg"/>
        <Collapse in={checked} collapsedHeight={collapsedHeight} className="index-calendar-collapse">
          {/*<Collapse collapsedHeight={collapsedHeight} className="index-calendar-collapse">*/}
          <IndexCalendar dateWidth={dateWidth} selectDate={date} index={index} checked={checked}
                         handleDateChange={val => {
                           this.handleDateChange(val)
                         }}/>
          {true && (<div style={{textAlign: "center"}}>
            <Button disabled={(() => {
              let sy = date._d.getFullYear() * 12 + date._d.getMonth();
              let cy = new Date().getFullYear() * 12 + new Date().getMonth();
              return index + sy - cy <= 0
            })()} className="index-left-arrow" onClick={() => {
              this.setState({index: this.state.index - 1})
            }}>
              <ArrowBackIos style={{fontSize: "16px", color: "#fff"}}/>
            </Button>
            <Button className="index-left-arrow" onClick={() => {
              this.setState({index: this.state.index + 1})
            }}>
              <ArrowForwardIos style={{fontSize: "16px", color: "#fff"}}/>
            </Button>
          </div>)}
        </Collapse>
        <div style={{textAlign: "center", position: "relative", zIndex: 14}}>
          <img className="index-date-arrow" src={DownPng}
               style={{transform: checked ? "rotate(180deg)" : "rotate(0deg)"}} width={16} onClick={() => {
            this.setState({checked: !checked});
            this.addBodyFixed();
          }} alt="arrow"/>
          <div className="index-date-tips">
            <span>六</span>
            <span>日</span>
          </div>
        </div>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <DatePicker
            margin="normal"
            value={date}
            cancelLabel="取消"
            okLabel="确定"
            onClose={() => {
              document.body.style.position = "";
              this.setState({index: 0, checked: false});
              // this.refs.dp.cloae();
            }}
            onChange={e => this.handleDateChange(e)}
            ref="dp"
            style={{display: "none"}}
          />
        </MuiPickersUtilsProvider>
      </div>
    </div>);
  }

  // style={{ minHeight: "70vh" }}
  // 渲染首页的房间
  renderMeetingRoom(date) {
    let IndexRoomBar = <div className="index-room-title-list">
      {false && this.state.meetingRoom.map(room => {
        const {id, name, reservationsList} = room;
        if (this.state.detailRoom.id && this.state.detailRoom.id == id) {
          return (<span key={id} style={{color: 'black'}} onClick={() => {
            this.setState({detailRoom: room})
          }}>{name}</span>);
        } else {
          return (<span key={id} onClick={() => {
            this.setState({detailRoom: room})
          }}>{name}</span>);
        }
      })}
    </div>;
    if (this.state.detailRoom.id) {
      return (<div className="index-room-list">
        {IndexRoomBar}
        <div className="arrangement-section">
          {this.renderDetailRoomArrangement()}
        </div>
      </div>);
    } else {
      return (<div className="index-room-list">
        {IndexRoomBar}
        {this.state.meetingRoom.map(room => {
          const {id, name, reservationsList} = room;
          return (
            <div className="index-room-list-item arrangement-section" key={id}>
              <div className="index-room-list-top">
                <span className="index-room-list-item-name">{name}</span>
                <Link to={`${ROOM_DETAIL_LINK}/${id}`} className="index-room-list-item-detail">
                  详情
                  <ArrowForwardIos style={{fontSize: "14px", verticalAlign: "middle"}}/>
                </Link>
              </div>
              {this.renderRoomArrangement(reservationsList.sort((a, b) => {
                return a.start - b.start
              }).filter(item => {
                return moment(item.end) > moment()
              }), room)}
            </div>
          );
        })}
      </div>);
    }
  }

  renderMeetingRoom_pic(date) {
    return (<div className="index-room-list">
      <ul className="index-room-pic-list">
        {this.state.meetingRoom.map(room => {
          const {id, name, reservationsList, mediaList, capacity} = room;
          let picurl = `${mediaList[0].url}`
          return <li className={"index-room-pic-lis-li"} onClick={() => {
            console.log("cli", `${ROOM_DETAIL_LINK}/${id}`)
            window.location.hash = `${ROOM_DETAIL_LINK}/${id}`
          }}>
            <div className={'index-room-pic-lis-pic'}>
              <img src={picurl}/>
            </div>
            <div className={'index-room-pic-lis-title'} key={id} style={{color: 'black'}}>
              <div className={"name"}>{name}</div>
              <div className={"icon_count"}>
                <img style={{
                  VerticalAlign: "middle", MarginRight: "5px"
                }}
                     src={icon_count} alt="icon" height="14"/>{capacity}人
              </div>
              <div className="reserve-status">
                {room.projector_status && <img src={IconVideo} alt="icon" height={14}/>}
                {room.computer_status && <img src={IconLaptop} alt="icon" height={14}/>}
                {room.board_status && <img src={IconBlackboard} alt="icon" height={14}/>}
                {room.soundDevice_status && <img src={Iconspeaker} alt="icon" height={14}/>}
              </div>
            </div>
          </li>
        })}
      </ul>
    </div>);
  }

  // 渲染筛选后详细房间的排期
  renderDetailRoomArrangement() {
    const {detailRoom, date} = this.state;
    if (detailRoom.reservationsList.length === 0) {
      return (
        <React.Fragment>
          <Link to={{
            pathname: `${ROOM_FORM_LINK}`,
            state: {room: detailRoom, timeStamp: date.valueOf()}
          }} className="index-room-noArrangement">
            当天没有预约，马上约
          </Link>
          <Link to={{
            pathname: `${ROOM_FORM_LINK}`,
            state: {room: detailRoom, timeStamp: date.valueOf()}
          }} className="index-room-reserve">
            预约
          </Link>
        </React.Fragment>
      );
    } else {
      const reservationPanel = [];
      detailRoom.reservationsList = detailRoom.reservationsList.sort((a, b) => {
        return a.start - b.start
      })

      for (let i = 0; i < detailRoom.reservationsList.length; i++) {
        const reservation = detailRoom.reservationsList[i];

        let rang = moment(reservation.start).format('A');
        let color = ["#006AC7", "#006AC7", "#006AC7", "#BD10E0", "#2EB872"][['早上','上午', '中午', '下午', '晚上'].indexOf(rang)];

        reservationPanel.push(
          <ExpansionPanel key={i} className="arrange-content" in={"true"} timeout="auto" style={{borderColor: color}}>
            {/*<ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>*/}
            <ExpansionPanelSummary>
              <Typography>
                <span className="content-purpose">{reservation.purpose}</span>
                <span className="content-date">
          {moment(reservation.start).format("HH:mm")} -{" "}
                  {moment(reservation.end).format("HH:mm")}
                  &nbsp;&nbsp;{reservation.name}
                  </span>
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Typography>
                <span className="content-desc">{reservation.description}</span>
              </Typography>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        );
        if (i !== detailRoom.reservationsList.length - 1) {
          // 渲染中间的时间段
          let currentEnd = detailRoom.reservationsList[i].end;
          let nextStart = detailRoom.reservationsList[i + 1].start;
          if (nextStart - currentEnd >= 3 * 60 * 60 * 1000) {
            reservationPanel.push(
              <div key={currentEnd} style={{lineHeight: "88px"}} className="index-pannel-timeSlot">
          <span>
          {moment(currentEnd).format("HH:mm")} ~{" "}
            {moment(nextStart).format("HH:mm")}
          </span>
              </div>
            );
          } else if (nextStart - currentEnd >= 2 * 60 * 60 * 1000) {
            reservationPanel.push(
              <div key={currentEnd} style={{lineHeight: "66px"}} className="index-pannel-timeSlot">
          <span>
          {moment(currentEnd).format("HH:mm")} ~{" "}
            {moment(nextStart).format("HH:mm")}
          </span>
              </div>
            );
          } else if (nextStart - currentEnd >= 1 * 60 * 60 * 1000) {
            reservationPanel.push(
              <div key={currentEnd} className="index-pannel-timeSlot">
          <span>
          {moment(currentEnd).format("HH:mm")} ~{" "}
            {moment(nextStart).format("HH:mm")}
          </span>
              </div>
            );
          }
        }
      }
      return (
        <div>
          {reservationPanel}
          <Link to={{
            pathname: `${ROOM_FORM_LINK}`,
            state: {room: detailRoom, timeStamp: date.valueOf()}
          }} className="index-room-reserve">预约</Link>
        </div>
      );
    }
  }

  // 渲染没筛选前详细房间的排期
  renderRoomArrangement(reservationsList, room) {
    const {date} = this.state;
    if (reservationsList.length === 0) {
      return (
        <React.Fragment>
          <Link
            to={{
              pathname: `${ROOM_FORM_LINK}`,
              state: {room: room, timeStamp: date.valueOf()}
            }}
            className="index-room-noArrangement"
          >
            当天没有预约，马上约
          </Link>
        </React.Fragment>
      );
    } else {
      const arrangement = [];
      for (let idx = 0; idx < reservationsList.length; idx++) {
        let data = reservationsList[idx];
        let rang = moment(data.start).format('A');
        let color = ["#006AC7", "#006AC7", "#006AC7", "#BD10E0", "#2EB872"][['早上','上午', '中午', '下午', '晚上'].indexOf(rang)];
        console.log(rang)
        // if (idx > 2) {
        //   return <div key={idx}/>;
        // }
        arrangement.push(
          <ExpansionPanel
            key={idx}
            className="arrange-content"
            in={"true"}
            timeout="auto"
            style={{borderColor: color}}
          >
            {/*<ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>*/}
            <ExpansionPanelSummary>
              <Typography style={{width: "100%", paddingRight: '0'}}>
                <div className="arrange-content-left">
                  <span className="content-date" style={{color: color}}>
          {/*{start.format("HH:mm A")}*/}
                    {moment(data.start).format('HH:mm')} ~ {moment(data.end).format('HH:mm')}
          </span>
                  <span className="content-date-between">
              {/*{hour !== 0 ? hour + "小时" : ""}*/}
                    {/*    {min !== 0 ? min + "分钟" : ""}*/}
                    {/*{moment(data.start).format('HH:mm')} ~ {moment(data.end).format('HH:mm')}*/}
                    {moment(data.end).diff(moment(data.start), 'hours')}小时
                    {moment(data.end).diff(moment(data.start), "minute") % 60}分钟
          </span>
                </div>
                <div className="arrange-content-right">
                  <span className="content-purpose">{data.purpose}</span>
                  <span className="content-name">{data.name} {data.count}人</span>
                </div>
              </Typography>
            </ExpansionPanelSummary>
            {/*<ExpansionPanelDetails>*/}
            {/*  <Typography>*/}
            {/*    <span className="content-desc">{data.description}</span>*/}
            {/*  </Typography>*/}
            {/*</ExpansionPanelDetails>*/}
          </ExpansionPanel>
        );
        if (idx !== reservationsList.length - 1) {
          // 渲染中间的时间段
          let currentEnd = reservationsList[idx].end;
          let nextStart = reservationsList[idx + 1].start;
          if (nextStart - currentEnd >= 1 * 60 * 60 * 1000) {
            arrangement.push(
              <Link
                to={{
                  pathname: `${ROOM_FORM_LINK}`,
                  state: {room: room, timeStamp: date.valueOf()}
                }}>
                <div
                  key={currentEnd}
                  className="index-pannel-timeSlot"
                >
                  {moment(currentEnd).format('HH:mm')}-{moment(nextStart).format('HH:mm')}&nbsp;&nbsp;&nbsp;&nbsp;
                  {moment(nextStart).diff(currentEnd, "hours")}小时空闲
                </div>
              </Link>
            );
          }
        }
      }
      return (
        <div className="index-room-main">
          {arrangement}
          {reservationsList.length > 3 && (<div onClick={() => this.selectDetailRoom(room)} className="index-room-more">
            <img
              src={ArrangementMore}
              width={34}
              alt="more"
              style={{verticalAlign: "middle"}}
            />
          </div>)}
          {/*<React.Fragment>*/}
          {/*  <Link*/}
          {/*    to={{*/}
          {/*      pathname: `${ROOM_FORM_LINK}`,*/}
          {/*      state: {room: room, timeStamp: date.valueOf()}*/}
          {/*    }}*/}
          {/*    className="index-room-noArrangement msy"*/}
          {/*  >*/}
          {/*    马上约*/}
          {/*  </Link>*/}
          {/*</React.Fragment>*/}
        </div>
      );
    }
  }

  renderFilterDiv() {
    const {meetingRoom, detailRoom, filter} = this.state;
    return (
      <div
        className="filter-div"
        style={{transform: filter ? "scale(1)" : "scale(0)"}}
      >
        <div className="filter-top">
          <div
            className="filter-close"
            onClick={() => this.setState({filter: false})}
          >
            <CloseIcon style={{fontSize: 14, verticalAlign: "middle"}}/>
          </div>
          <span>会议室筛选</span>
        </div>
        <div className="filter-contain">
          <div
            className={detailRoom.id ? "filter-all" : "filter-all active"}
            onClick={() => this.selectAll()}
          >
            全部
          </div>
          <div className="filter-room-div">
            {meetingRoom.map((room, idx) => {
              return (
                <div
                  className={
                    detailRoom.id === room.id
                      ? "filter-room-detail active"
                      : "filter-room-detail"
                  }
                  onClick={() => this.selectDetailRoom(room)}
                  key={idx}
                >
                  {room.mediaList[0] && (
                    <img
                      src={room.mediaList[0].url}
                      width="100%"
                      alt="roomImg"
                    />
                  )}
                  {room.name}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  // 选择房间
  selectAll() {
    this.setState({detailRoom: {}, filter: false}, () =>
      this.getReservations()
    );
  }

  selectDetailRoom(room) {
    this.setState({detailRoom: room, filter: false}, () =>
      this.getReservations()
    );
  }

  getDuration(start, end) {
    let timeStamp = (end - start) / 1000;
    let hour = parseInt(timeStamp / 3600);
    let minute = (timeStamp % 3600) / 60;
    let duration = "";
    if (hour !== 0) {
      duration = hour + "小时";
    }
    if (minute !== 0) {
      duration += minute + "分钟";
    }
    return duration;
  }
}

export default connect(null, {checkAuth})(Index);
// export default Index;